<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
body {
    font-family: "\5FAE\8F6F\96C5\9ED1","Microsoft Yahei","Hiragino Sans GB",tahoma,arial,"\5B8B\4F53";
    min-width: 1260px;
    margin: 0;
}
a{
  text-decoration: none;
  outline: 0;
  background-color: transparent;
}
article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section, summary {
    display: block;
}
button, input, optgroup, select, textarea {
    color: inherit;
    font: inherit;
    margin: 0;
}
input {
    line-height: normal;
}
input[type=tel], input[type=password], input[type=text], textarea {
    width: 100%;
    padding: .8225em;
    font-size: 14px;
    color: #333;
    border: 1px solid #ddd;
    border-radius: 0;
    background-color: #fff;
    outline: 0;
}
::-webkit-input-placeholder { /* WebKit browsers */
  color: #ccc;
  /* font-size: 16px; */
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #ccc;
  /* font-size: 16px; */
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #ccc;
  /* font-size: 16px; */
}  
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
* {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    word-break: break-word;
    white-space: normal;
    word-wrap: break-word;
}
.inline {
    display: inline-block;
    vertical-align: middle;
}
.show-more{
  margin: 20px auto 80px auto;
  color: #ccc;
}
.show-more:hover{
  color: rgb(99, 95, 95);
}
</style>
